export default __webpack_public_path__ + "static/media/mongodb2.5ccaf82e.svg";